import React from 'react'
import { BiLink } from 'react-icons/bi'
import '../css/Portfolio.css'
import { useTranslation } from 'react-i18next'

const Portfolio = () => {

    const { t, i18n } = useTranslation();

    return (
        <div>
            <h1 className="border-bottom w-75 m-4 border-warning">{t('portfolio')}</h1>

            <div className="portfolio  p-2">
                
                <div className="portfolio-item">
                    {/* <iframe src="https://soliteams.web.app" width="100%" height="80%"></iframe><br/> */}
                    <img src="soliteams.png" width="100%" height="80%" style={{background:'soliteams.png'}} /> <br/>
                    <a href="https://soliteams.web.app"> <BiLink className="m-1"/> soli Teams chat</a>
                </div>

                <div className="portfolio-item">
                    {/* <iframe src="https://solibook.web.app" width="100%" height="80%"></iframe><br/> */}
                    <img src="solibook.png" width="100%" height="80%" style={{background:'soliteams.png'}} /> <br/>
                    <a href="https://solibook.web.app"> <BiLink className="m-1"/> soli face Book</a>
                </div>
                
                <div className="portfolio-item">
                    {/* <iframe src="https://soli.pythonanywhere.com" width="100%" height="80%"></iframe><br/> */}
                    <img src="soliweather.png" width="100%" height="80%" style={{background:'soliteams.png'}} /> <br/>
                    <a href="https://soli.pythonanywhere.com"> <BiLink className="m-1"/> soliweather</a>
                </div>
                

            </div>

        </div>
    )
}

export default Portfolio
